import React,{useState,useEffect} from 'react';
import { Skeleton, Box ,Typography} from '@mui/material';

const SurveySkeleton = ({isLoading}) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000); // Increment the counter every 1 second

    // Clean up the interval when the component is unmounted
    return () => clearInterval(interval);
  }, []);

  useEffect(()=>{
    if(isLoading){
      setSeconds(0)
    }
  },[isLoading])

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h6" sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1 }}>
        Loading {seconds} sec... please wait
      </Typography>        
      {/* Skeleton for survey title */}
      <Skeleton variant="text" width="60%" height={40} />

      {/* Skeleton for question 1 */}
      <Box sx={{ marginTop: 2 }}>
        <Skeleton variant="text" width="80%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={40} sx={{ marginTop: 1 }} />
      </Box>

      {/* Skeleton for question 2 */}
      <Box sx={{ marginTop: 2 }}>
        <Skeleton variant="text" width="80%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={40} sx={{ marginTop: 1 }} />
      </Box>

      {/* Skeleton for checkbox question */}
      <Box sx={{ marginTop: 2 }}>
        <Skeleton variant="text" width="80%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={40} sx={{ marginTop: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={40} sx={{ marginTop: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={40} sx={{ marginTop: 1 }} />
      </Box>

      {/* Skeleton for submit button */}
      <Box sx={{ marginTop: 3 }}>
        <Skeleton variant="rectangular" width="40%" height={50} />
      </Box>
    </Box>
  );
};

export default SurveySkeleton;
